import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/API/api.service';

@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.scss']
})
export class LoginRegisterComponent implements OnInit {

  loginForm: FormGroup;
  registerForm: FormGroup;
  loading: boolean = false

  constructor(private formBuilder: FormBuilder,private apiService: ApiService,private router: Router) {
    this.loginForm = this.formBuilder.group({
      phone:['',[Validators.required,Validators.pattern(/^01\d{9}$/)]],
      password:['',[Validators.required,Validators.minLength(6)]]
    })

    this.registerForm = this.formBuilder.group({
      name:['',[Validators.required]], // done
      phone:['',[Validators.required,Validators.pattern(/^01\d{9}$/)]], // done
      sec_phone:['',[Validators.pattern(/^01\d{9}$/)]], // done
      password:['',[Validators.required,Validators.minLength(8)]], //
      password_confirmation:['',[Validators.required,Validators.minLength(8),this.passwordMatchValidator]], //
      address:['',[Validators.required]], //
      city_id:[{value: 'Asyut', disabled: true},[Validators.required]], //
      building:['',[Validators.required]], //
      floor:['',[Validators.required]], //
      flat:['',[Validators.required]], //
      special_mark:['',[Validators.required]], //
      gender:['',[Validators.required]], //
      lang:['ar'], //
      fcm_token:['',[Validators.required]], //
      email:['',[Validators.required,Validators.email]], //
    })
  }
  
  get f() { return this.loginForm.controls; }
  get f2() { return this.registerForm.controls; }

  passwordMatchValidator(control: any) {
    const password = control?.parent?.get('password')?.value;
    const confirmPassword = control?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }
  ngOnInit(): void {
  }

  login(){
    if(this.loginForm.valid){
      this.loading = true
      this.apiService.Login(this.loginForm.value).subscribe({
        next: (response)=>{
          const isVerified = response.data.user.is_verified
          if(isVerified == 1){
            this.loading = false
            localStorage.setItem('userToken',response.data.token)
            localStorage.setItem('userData',JSON.stringify(response.data.user))
            localStorage.setItem('userLogged','true')
            this.showSuccess = true
            this.successMsg = 'تم تسجيل الدخول بنجاح'
            setTimeout(() => {
              this.showSuccess = false
              this.successMsg = ''
              window.history.back()
            }, 2000);
          }else{
            this.loading = false
            localStorage.setItem('userToken_to_verify', response.data.token);
            this.showError = true
            this.errorMsg = "برجاء تفعيل حسابك بالكود المرسل إلى بريدك الإلكتروني"
            this.userEmail = response.data.user.email
            this.sendOtpToMailIfLoginFailed(this.userEmail)
            setTimeout(() => {
              this.errorMsg = ''
              this.showError = false
            }, 3000);
          }
        },error: (error: HttpErrorResponse) =>{
          this.loading = false
          console.log(error)
          this.showError = true
          this.errorMsg = error.error.message
          if(this.errorMsg == null || this.errorMsg == ''){
            this.errorMsg = 'حدث خطأ ما برجاء المحاولة مرة أخرى'
          }
          setTimeout(() => {
            this.showError = false
            this.errorMsg = ''
          }, 3000);
        }})
    }
  }

  sendOtpToMailIfLoginFailed(email: string) {
    // this.isResending = true
    const formData = new FormData();
    formData.append('email', email);
    if(email) {
      this.apiService.sendOtpToMailAfterSignup(formData).subscribe({
        next: (response) => {
          this.showSuccessOTP = true;
          this.successMsgOTP = 'تم إرسال كود التفعيل إلى بريدك الإلكتروني';
          this.startOtpCountdown();
          this.showOtpModal = true;
          setTimeout(() => {
            this.showSuccessOTP = false;
          }, 3000);
        },
        error: (error: HttpErrorResponse) => {
          this.showError = true;
          this.errorMsg = error.error.message;
          setTimeout(() => {
            this.showError = false;
          }, 3000);
        }
      });
    }
  }

  validateNumber(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const input = event.key;

    // Check if the input is a number or a special key (like backspace or delete)
    if (allowedKeys.includes(input) || event.code.startsWith('Arrow') || event.code === 'Backspace' || event.code === 'Delete') {
      // Check the current length of the input
      if ((event.target as HTMLInputElement).value.length >= 11 && event.code !== 'Backspace' && event.code !== 'Delete') {
        event.preventDefault(); // Prevent further input
      }
    } else {
      event.preventDefault(); // Prevent input if not a number or special key
    }
  }

  changeGenderValue(gender: string){
    if(gender == 'male'){
      this.registerForm.patchValue({
        gender: 'male'
      })
    }else if(gender == 'female'){
      this.registerForm.patchValue({
        gender: 'female'
      })
    }
  }

  errorMsg = ''
  successMsg = ''
  showError: boolean = false
  showSuccess: boolean = false
  // signUp(){
  //   const fcm = localStorage.getItem('FCM_Token')
  //   this.registerForm.patchValue({
  //     fcm_token: fcm
  //   })
  //   if(this.registerForm.valid){
  //     const formData = new FormData
  //     formData.append('name',this.registerForm.value.name)
  //     formData.append('email',this.registerForm.value.email)
  //     formData.append('password',this.registerForm.value.password)
  //     formData.append('password_confirmation',this.registerForm.value.password_confirmation)
  //     formData.append('phone',this.registerForm.value.phone)
  //     formData.append('sec_phone',this.registerForm.value.sec_phone)
  //     formData.append('gender',this.registerForm.value.gender)
  //     formData.append('fcm_token',this.registerForm.value.fcm_token)
  //     formData.append('lang',this.registerForm.value.lang)
  //     formData.append('city_id','2')
  //     formData.append('address',this.registerForm.value.address)
  //     formData.append('building',this.registerForm.value.building)
  //     formData.append('floor',this.registerForm.value.floor)
  //     formData.append('flat',this.registerForm.value.flat)
  //     formData.append('special_mark',this.registerForm.value.special_mark)

  //     this.apiService.signup(formData).subscribe({
  //       next: (response) => {
  //         console.log(response)
  //         if(response.success == true){
  //           this.showSuccess = true
  //           this.successMsg = "تم انشاء الحساب بنجاح"
  //           setTimeout(() => {
  //             this.showSuccess = false
  //             this.successMsg = ''
  //           }, 3000);
  //         }
  //       }, error: (error: HttpErrorResponse) => {
  //         console.log(error.error.message)
  //         this.showError = true
  //         this.errorMsg = error.error.message
  //         setTimeout(() => {
  //           this.showError = false
  //           this.errorMsg = ''
  //         }, 3000);
  //       }
  //     })
  //   }

  //   // console.log(this.registerForm)
  // }



  // new functions
  // Add these properties to your component
  showOtpModal: boolean = false;
  otp: string[] = new Array(6).fill('');
  otpCountdown: number = 60;
  otpTimer: any;
  userEmail: string = '';
  isResendEnabled: boolean = false;
  successMsgOTP: string = '';
  showSuccessOTP: boolean = false;

  // Updated signUp function
  signUp(){
    this.loading = true
    this.registerForm.markAllAsTouched()
      const fcm = localStorage.getItem('FCM_Token')
      this.registerForm.patchValue({
        fcm_token: fcm || 'null' 
      })
      if(this.registerForm.valid){
        const formData = new FormData
        formData.append('name',this.registerForm.value.name)
        formData.append('email',this.registerForm.value.email)
        formData.append('password',this.registerForm.value.password)
        formData.append('password_confirmation',this.registerForm.value.password_confirmation)
        formData.append('phone',this.registerForm.value.phone)
        formData.append('sec_phone',this.registerForm.value.sec_phone)
        formData.append('gender',this.registerForm.value.gender)
        formData.append('fcm_token',this.registerForm.value.fcm_token)
        formData.append('lang',this.registerForm.value.lang)
        formData.append('city_id','2')
        formData.append('address',this.registerForm.value.address)
        formData.append('building',this.registerForm.value.building)
        formData.append('floor',this.registerForm.value.floor)
        formData.append('flat',this.registerForm.value.flat)
        formData.append('special_mark',this.registerForm.value.special_mark)

        this.apiService.signup(formData).subscribe({
          next: (response) => {
            console.log(response)
            if(response.success == true){
              this.loading = false
              // Store token for verification
              localStorage.setItem('userToken_to_verify', response.data.token);
              this.userEmail = this.registerForm.value.email;
              
              // Show success message
              this.showSuccessOTP = true
              this.successMsgOTP = "تم انشاء الحساب بنجاح - يرجى تفعيل الحساب عبر الكود المرسل إلى بريدك الإلكتروني"
              
              // Show OTP modal after delay
              setTimeout(() => {
                this.showOtpModal = true;
                this.startOtpCountdown();
                this.sendOtpAfterSignup();
              }, 1000);
            }
          }, error: (error: HttpErrorResponse) => {
            this.loading = false
            console.log(error.error.message)
            this.showError = true
            this.errorMsg = error.error.message
            setTimeout(() => {
              this.showError = false
              this.errorMsg = ''
            }, 3000);
          }
        })
      }
  }

  // OTP Functions
  startOtpCountdown() {
    this.otpCountdown = 60;
    this.isResendEnabled = false;
    
    this.otpTimer = setInterval(() => {
      this.otpCountdown--;
      
      if (this.otpCountdown <= 0) {
        clearInterval(this.otpTimer);
        this.isResendEnabled = true;
      }
    }, 1000);
  }

  sendOtpAfterSignup() {
    const formData = new FormData();
    formData.append('email', this.userEmail);
    
    this.apiService.sendOtpToMailAfterSignup(formData).subscribe({
      next: (response) => {
        if(response.success == true){
          this.startOtpCountdown();
        }
        this.showSuccessOTP = true;
        this.successMsgOTP = 'تم إرسال كود التفعيل إلى بريدك الإلكتروني';
        setTimeout(() => {
          this.showSuccessOTP = false;
        }, 3000);
      },
      error: (error: HttpErrorResponse) => {
        this.showError = true;
        this.errorMsg = 'فشل في إرسال كود التفعيل';
        setTimeout(() => {
          this.showError = false;
        }, 3000);
      }
    });
  }

  resendOtp() {
    if (this.isResendEnabled) {
      this.sendOtpAfterSignup();
    }
  }

  onOtpInput(event: any, index: number) {
    const input = event.target;
    const value = input.value;
    
    // Only allow numbers
    if (!/^\d*$/.test(value)) {
      input.value = '';
      this.otp[index] = '';
      return;
    }
    
    // Update OTP array
    this.otp[index] = value;
    
    // Auto focus next input
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
    
    // Check if all OTP digits are filled
    if (this.otp.every(digit => digit !== '')) {
      this.verifyOtp();
    }
  }

  onOtpKeyDown(event: any, index: number) {
    // Handle backspace
    if (event.key === 'Backspace' && !this.otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

  verifyOtp() {
    const otpCode = this.otp.join('');
    
    if (otpCode.length !== 6) {
      this.showError = true;
      this.errorMsg = 'يرجى إدخال الكود المكون من 6 أرقام';
      setTimeout(() => {
        this.showError = false;
      }, 3000);
      return;
    }

    const formData = new FormData();
    // formData.append('email', this.userEmail);
    formData.append('otp_code', otpCode);
    formData.append('type', 'verify');

    const bayload = {
      otp_code: otpCode,
      type: 'verify'
    }
    this.apiService.verifyOtp(bayload).subscribe({
      next: (response) => {
        if (response.success == true) {
          // Clear timer and close modal
          this.showSuccessOTP = true;
          this.successMsgOTP = 'تم تفعيل الحساب بنجاح';
          clearInterval(this.otpTimer);

          this.showOtpModal = false;
          localStorage.removeItem('userToken_to_verify');

          console.log(response)
          
          setTimeout(() => {
            this.showSuccessOTP = false;
            window.location.reload()
          }, 3000);
          
          // Store the actual token and user data
          // const token = localStorage.getItem('userToken_to_verify');
          // localStorage.setItem('userToken', token || '');
          // localStorage.setItem('userData', JSON.stringify(response.data.user));
          // localStorage.setItem('userLogged', 'true');
          
          
        }
      },
      error: (error: HttpErrorResponse) => {
        this.showError = true;
        this.errorMsg = error.error.message || 'كود التفعيل غير صحيح';
        setTimeout(() => {
          this.showError = false;
        }, 3000);
        
        // Clear OTP fields
        this.otp = new Array(6).fill('');
        // Focus on first input
        const firstInput = document.getElementById('otp-0');
        if (firstInput) {
          firstInput.focus();
        }
      }
    });
  }

  closeOtpModal() {
    this.showOtpModal = false;
    clearInterval(this.otpTimer);
    this.otp = new Array(6).fill('');
  }
}
